<template>
    <div class="module-list">
        <div class="column">
            <div class="label">
                Modul 1
            </div>
            <h3>
                {{ getModuleMainTitle(modulesColumn1[0]) }}
            </h3>
            <ModuleTeaser
                v-for="module in modulesColumn1"
                :key="module"
                :module="module"
            />
        </div>
        <div class="column">
            <div class="label">
                Modul 2
            </div>
            <h3>
                {{ getModuleMainTitle(modulesColumn2[0]) }}
            </h3>
            <ModuleTeaser
                v-for="module in modulesColumn2"
                :key="module"
                :module="module"
            />
        </div>
    </div>
</template>

<script>
import modules from '@/static/modules.json';
import ModuleTeaser from './ModuleTeaser.vue';

export default {
    name: 'ModuleList',
    components: {
        ModuleTeaser
    },
    data: () => ({
        modulesColumn1: ['1.1', '1.2'],
        modulesColumn2: ['2.1', '2.2', '2.3', '2.4']
    }),
    methods: {
        getModuleMainTitle(module)
        {
            return modules[module].mainTitle;
        }
    }
};
</script>

<style lang="scss" src="./ModuleList.scss" />
